<template>
  <CommonTable
    width="150"
    ref="table"
    :data="tableData"
    :total="total"
    :needIndex="true"
    @change="handleTableChange"
    :table-json="tablejson"
  >
  </CommonTable>
</template>

<script>
import tablejson from './Model/Tablejson.Alarm'
import formTableMixin from '@manage/mixins/formTableMixin'

export default {
  mixins: [formTableMixin],
  props: {
    assetNumber: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tablejson,
      queryApi: this.$api.freezer.alarm_list
    }
  },
  methods: {
    formSearch() {
      const params = {
        devType: '02',
        assetNumber: this.assetNumber
      }
      this.search(params, null, this.queryApi)
    }
  }
}
</script>

<style lang="less" scoped></style>
